// @flow
import Checkbox from "./Checkbox";
import "./Checkbox.scss";
import { deepClone, shouldRenderChoice } from "../../../../../utils/helpers";
import {faCaretDown } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { useState } from "react";

type Props = {
    choices?: Array,
    metadata?: Object,
    onChange: Function,
    question: object,
};

export default function CheckBoxContainer({
    choices,
    question,
    onChange,
    metadata,
}: Props): React$Element<any> {
    const [secondaryVisible, setSecondaryVisible] = useState(false);
    const maxSelection = metadata?.validation_max_selection;
    const isDynamic = question?.dynamic;

    let currentChoices = deepClone(choices);
    const secondaryChoices = [];
    let primaryChoices = [];

    // for conditional rendering
    const loadMore = metadata?.load_more && metadata?.load_more === "true";

    if (loadMore) {
        currentChoices.forEach((choice) => {
            const choiceMetadata = choice.metadata;

            if (choiceMetadata?.primary !== "true") {
                secondaryChoices.push(choice);
                if (choice.selected && secondaryVisible === false)
                    setSecondaryVisible(true);
            } else {
                primaryChoices.push(choice);
            }
        });
    } else {
        primaryChoices = currentChoices;
    }

    const onChangeValue = (id, selectedChoice, selected: boolean) => {
        const concernsArray = [
            "therapyNoHelpfulConcern",
            "therapyHelpfulConcernP2",
        ];

        if (!isMaxSelected(selectedChoice)) {
            currentChoices = currentChoices.map((choice) => {
                if (choice.id === id) {
                    choice.selected = selected;
                    if (!selected) choice.value = null;
                } else {
                    if (
                        concernsArray.includes(question.frontend_identifier) &&
                        selectedChoice?.metadata?.clear_other === "true" &&
                        isDynamic
                    ) {
                        if (selected) {
                            // selected
                            choice.selected = false;
                            choice.value = null;
                        }
                    } else if (
                        selectedChoice?.metadata?.clear_other === "true" &&
                        !isDynamic
                    ) {
                        if (selected) {
                            // selected
                            choice.selected = false;
                            choice.value = null;
                        }
                    } else {
                        if (
                            concernsArray.includes(
                                question.frontend_identifier
                            ) &&
                            choice?.metadata?.clear_other === "true" &&
                            isDynamic
                        ) {
                            choice.selected = false;
                            choice.value = null;
                        } else if (
                            choice?.metadata?.clear_other === "true" &&
                            !isDynamic
                        ) {
                            choice.selected = false;
                            choice.value = null;
                        }
                    }
                }

                return choice;
            });

            onChange(null, currentChoices);
        }
    };

    const isMaxSelected = (selectedChoice) => {
        if (!maxSelection) return false;
        const isSelected = !selectedChoice.selected;
        const currentSelectionCount = currentChoices.filter(
            (c) => c.selected === true
        ).length;

        if (isSelected === true) {
            if (currentSelectionCount === maxSelection) {
                return true;
            }
        }

        return false;
    };

    const onInputValueChange = (value, choice) => {

        if (value.length === 1 && value.trim() !== value) {
            return;
        }

        currentChoices = currentChoices.map((c) => {
            if (c.id === choice.id) {
                c.value = value;
            } else {
                const renderCurrentChoice = shouldRenderChoice(
                    c,
                    primaryChoices
                );

                if (!renderCurrentChoice) {
                    c.selected = false;
                    c.value = null;
                }
            }

            return c;
        });

        onChange(null, currentChoices);
    };

    return (
        <div className="checkbox-container">
            <div className="row">
                {primaryChoices &&
                    primaryChoices.map((choice) => {
                        const renderCurrentChoice = shouldRenderChoice(
                            choice,
                            primaryChoices
                        );

                        return (
                            renderCurrentChoice && (
                                <div className={"col-md-6"} key={choice.id}>
                                    <Checkbox
                                        key={choice.id}
                                        id={choice.id}
                                        choice={choice}
                                        selected={choice.selected || false}
                                        title={choice.title}
                                        onCheck={(id: any, selected: boolean) =>
                                            onChangeValue(
                                                choice.id,
                                                choice,
                                                selected
                                            )
                                        }
                                        inputValue={choice.value}
                                        onChange={(value: any) => {
                                            onInputValueChange(value, choice);
                                        }}
                                        hasOther={
                                            choice.metadata?.has_other || false
                                        }
                                    />
                                </div>
                            )
                        );
                    })}
            </div>
            {/* conditional rendering */}
            {loadMore && (
                <div className="row mt-4">
                    {!secondaryVisible && (
                        <div
                            className="row col-md-12"
                            onClick={() => {
                                setSecondaryVisible(true);
                            }}
                        >
                            <div className="load-more-text question-header">
                                {metadata.load_more_text || "Load More"}
                                <FontAwesomeIcon
                                 size="sm"
                                 className="caretdown-icon"
                                 icon={faCaretDown} />

                            </div>
                        </div>
                    )}
                    {secondaryVisible &&
                        secondaryChoices &&
                        secondaryChoices.map((choice) => (
                            <div className={"col-md-6"}>
                                <Checkbox
                                    key={choice.id}
                                    id={choice.id}
                                    choice={choice}
                                    selected={choice.selected || false}
                                    title={choice.title}
                                    onCheck={(id: any, selected: boolean) =>
                                        onChangeValue(
                                            choice.id,
                                            choice,
                                            selected
                                        )
                                    }
                                    inputValue={choice.value}
                                    onChange={(value: any) => {
                                        onInputValueChange(value, choice);
                                    }}
                                    hasOther={
                                        choice.metadata?.has_other || false
                                    }
                                />
                            </div>
                        ))}
                </div>
            )}
        </div>
    );
}
